module.exports = __webpack_public_path__ + "img/3_windAndRain_yjm.3394bbb2.png";